
































































import {ReportBody, ReportBodyCreateRequest} from "@/modules/cbc/models";
import CompanyDisplayComponent from "@/modules/country/components/CompanyDisplay.vue";
import {CountryMixin} from "@/modules/country/mixins";
import CurrencyDisplayComponent from "@/modules/currency/components/CurrencyDisplay.vue";
import {Component, Emit, Mixins, Prop} from "vue-property-decorator";

@Component({
	components: {
		CompanyDisplayComponent,
		CurrencyDisplayComponent
	}
})
export default class ReportBodyListComponent extends Mixins(CountryMixin) {
	@Prop({default: () => []})
	public readonly reportBody!: ReportBody[];
	public headers: any[] = [
		{
			text: "Jurisdiction",
			value: "jurisdiction",
			align: "start",
			divider: true,
			width: 150
		},
		{
			text: "Unrelated",
			value: "summary.unrelated",
			align: "end"
		},
		{
			text: "Related",
			value: "summary.related",
			align: "end"
		},
		{
			text: "Total",
			value: "summary.total",
			align: "end"
		},
		{
			text: "Profit Or Loss",
			value: "summary.profitOrLoss",
			align: "end"
		},
		{
			text: "Tax Paid",
			value: "summary.taxPaid",
			align: "end"
		},
		{
			text: "Tax Accrued",
			value: "summary.taxAccrued",
			align: "end"
		},
		{
			text: "Capital",
			value: "summary.capital",
			align: "end"
		},
		{
			text: "Earnings",
			value: "summary.earnings",
			align: "end"
		},
		{
			text: "NB Employees",
			value: "summary.nbEmployees",
			align: "end"
		},
		{
			text: "Assets",
			value: "summary.assets",
			align: "end"
		}
	];

	@Emit("create")
	public onCreate() {
		return {
			reportId: this.$route.params["reportId"],
			reportBody: {} as ReportBody
		} as ReportBodyCreateRequest
	}

	@Emit("get-report-body")
	public onClickRow(row: ReportBody) {
		return row;
	}
}
